module.exports = {
  type: 'hex-select',
  group: 'button',
  name: '下拉框',
  isForm: true,
  props: {
    type: {
      name: '是否禁用',
      default: false,
      type: 'enum',
      values: [{
        value: true,
        text: '是'
      }, {
        value: false,
        text: '否'
      }]
    },
    shape: {
      name: '是否支持多选',
      default: true,
      type: 'enum',
      values: [{
        value: true,
        text: '是'
      }, {
        value: false,
        text: '否'
      }]
    }
  },
  style: {},
  // 新的events 用来处理编译用
  interfaces: {
  },

  // events 保证原来不报错
  events: {}
}



// WEBPACK FOOTER //
// ./packages/components/select/src/define.js